import React from "react";

const SaveQuote = ({ setSaveQuote }) => {
  return (
    <div className="save-quote_card">
      <h2 className="title">£100 Discount Available</h2>
      <p className="save-quote-subtitle save-quote_subtitle--margin">
        Save your quote to receive a £100 discount off your fixed price quote
      </p>
      <button className="save-quote_btn" onClick={() => setSaveQuote(false)}>
        Close
      </button>
    </div>
  );
};

export default SaveQuote;
